module.exports = __webpack_public_path__ + "static/media/footerlogo-mobile.98819caf.png";